<!--首单优惠-->
<template>
  <basic-container>
    <div class="app-header">
      <el-form ref="query" :model="query" size="mini" :inline="true">
        <el-form-item label="活动名称：" prop="name">
          <el-input v-model="query.name" placeholder="请输入活动名称" clearable />
        </el-form-item>
        <el-form-item label="隶属公司：" prop="merchantIds">
          <YdMerchantSelector v-model="query.merchantIds" multiple placeholder="请选择隶属公司" />
        </el-form-item>
        <el-form-item label="状态：" prop="state">
          <avue-select
            v-model="query.state"
            placeholder="请选择状态"
            :dic="[
              { label: '待审核', value: 1 },
              // {label: '已通过', value: 2},
              { label: '已驳回', value: 3 },
              { label: '未开始', value: 4 },
              { label: '进行中', value: 5 },
              { label: '已结束', value: 6 },
              { label: '已下架', value: 7 }
            ]"
          />
        </el-form-item>
        <el-form-item label="开始时间：" prop="startTime">
          <avue-date
            v-model="query.startTime"
            type="date"
            format="yyyy-MM-dd"
            valueFormat="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="创建人：" prop="nameOrPhone">
          <el-input v-model="query.nameOrPhone" placeholder="请输入姓名或手机号码" />
        </el-form-item>

        <el-form-item label="线路：" prop="lineId">
          <YdLineSelector v-model="query.lineId" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchChange" :loading="loading"
            >筛选</el-button
          >

          <el-button type="danger" icon="el-icon-delete" @click="searchReset" :loading="loading"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="crud__container">
      <yd-table
        ref="crud"
        :columns="option.column"
        :loading="loading"
        :data="data"
        :pagination="page"
        @onChange="onTableChange"
        size="mini"
      >
        <template slot="tools">
          <el-button
            type="primary"
            size="mini"
            v-has-permi="['distCountCoupon_add']"
            icon="el-icon-circle-plus-outline"
            @click.stop="handleAdd"
            >新建活动</el-button
          >
        </template>
        <template slot-scope="{ row }" slot="name">
          <el-button type="text" size="small" @click="rowDetails(row)">
            {{ row.name }}
          </el-button>
        </template>

        <template slot-scope="{ row }" slot="menu">
          <el-dropdown
            size="mini"
            split-button
            type="primary"
            @command="(command) => handleCommand(command, row)"
          >
            操作
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="row.status === '待审核'">
                <el-button type="text" size="mini" v-has-permi="['distCountCoupon_examine']"
                  >通过</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item command="2" v-if="row.status === '待审核'">
                <el-button type="text" size="mini" v-has-permi="['distCountCoupon_examine']"
                  >不通过</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item
                command="3"
                v-if="row.status === '待审核' || row.status === '已驳回' || row.status === '未开始'"
              >
                <el-button type="text" size="mini" v-has-permi="['distCountCoupon_edit']"
                  >编辑</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item
                command="4"
                v-if="row.status === '进行中' || row.status === '已下架' || row.status === '已结束'"
                >数据</el-dropdown-item
              >
              <el-dropdown-item
                command="6"
                v-if="row.status === '未开始' || row.status === '进行中'"
              >
                <el-button type="text" size="mini" v-has-permi="['distCountCoupon_delete']"
                  >下架</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item command="5" v-if="row.status === '已驳回'"
                >查看原因</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </yd-table>
    </div>
    <activities-add ref="add" v-if="addVisible" @refreshDataList="refreshChange" />
    <activities-edit ref="activitiesEdit" v-if="editVisible" @refreshDataList="refreshChange" />
    <act-details ref="actDetails" v-if="detailsVisible" />
    <data-view ref="dataView" v-if="viewVisible" />

    <el-dialog title="审核不通过" :visible.sync="nVisible" :append-to-body="true" width="58%">
      <el-form ref="nInfo" :model="nInfo" size="small" label-width="99px" :rules="rules">
        <el-form-item label="不通过的原因" prop="remark">
          <el-input type="textarea" v-model="nInfo.remark" placeholder="请输入不通过原因" />
        </el-form-item>

        <el-form-item>
          <el-button type="info" @click="nVisible = !nVisible">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </basic-container>
</template>

<script>
  import ActivitiesAdd from '../components/activities/activities-add'
  import ActivitiesEdit from '../components/activities/activities-edit'
  import ActDetails from '../components/activities/activities-details'
  import DataView from '../components/activities/activities-data-view'
  import { list, edit } from '@/api/marketing/activities-api'

  export default {
    name: 'distcountCoupon',
    components: {
      ActivitiesAdd,
      ActivitiesEdit,
      ActDetails,
      DataView
    },
    data() {
      return {
        loading: false,
        addVisible: false,
        editVisible: false,
        detailsVisible: false,
        viewVisible: false,
        nVisible: false,
        query: {},
        data: [],
        page: {
          current: 1,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
          total: 0
        },
        option: {
          border: true,
          selection: true,
          tip: false,
          stripe: true,
          index: false,
          indexLabel: '序号',
          menuWidth: 350,
          simplePage: false,
          align: 'center',
          refreshBtn: true,
          searchSize: 'mini',
          addBtn: false,
          editBtn: false,
          delBtn: false,
          viewBtn: false,
          menu: false,
          column: [
            {
              label: '活动名称',
              prop: 'name',
              align: 'center',
              minWidth: 140
            },
            {
              label: '优惠金额',
              prop: 'money',
              align: 'center',
              width: 90
            },
            {
              label: '可用业务',
              prop: 'bu',
              align: 'center',
              width: 120,
              dicData: [
                {
                  label: '定制客运',
                  value: 1
                }
              ]
            },
            {
              label: '隶属公司',
              prop: 'merchantName',
              align: 'center',
              width: 180
            },
            {
              label: '线路/区域',
              prop: 'lineName',
              align: 'center',
              width: 150
            },
            {
              label: '开始时间',
              prop: 'startTime',
              align: 'center',
              width: 180
            },
            {
              label: '结束时间',
              prop: 'endTime',
              align: 'center',
              width: 180
            },
            {
              label: '创建人',
              prop: 'createUserName',
              align: 'center',
              width: 100
            },
            {
              label: '审核人',
              prop: 'auditorName',
              align: 'center',
              width: 100
            },
            {
              label: '审核时间',
              prop: 'auditTime',
              align: 'center',
              width: 180
            },
            {
              label: '状态',
              prop: 'status',
              align: 'center',
              width: 80
            },
            {
              label: '操作',
              prop: 'menu',
              align: 'center',
              width: 120,
              showOverflowTooltip: false
            }
          ]
        },
        nInfo: {},
        rules: {
          remark: [{ required: true, message: '请输入不通过的原因', trigger: 'blur' }]
        }
      }
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.page.current = current
        this.page.pageSize = pageSize
        this.onLoad()
      },
      rowDetails(row) {
        this.detailsVisible = true
        this.$nextTick(() => {
          this.$refs.actDetails.init(row)
        })
      },
      searchChange() {
        this.page.current = 1
        this.onLoad(this.page, this.query)
      },
      searchReset() {
        this.$refs.query.resetFields()
        this.onLoad(this.page)
      },
      onLoad(page, params = {}) {
        this.loading = true
        const adornData = {
          current: this.page.current,
          size: this.page.pageSize,
          ...this.quey
        }
        list(Object.assign(adornData, params))
          .then((resp) => {
            this.data = resp.data.records
            this.page.total = resp.data.total
          })
          .finally(() => {
            this.loading = false
          })
      },
      handleAdd() {
        this.addVisible = true
        this.$nextTick(() => {
          this.$refs.add.init()
        })
      },
      handleCommand(command, row) {
        if (command === '1') {
          const adonData = {
            id: row.id,
            state: 2
          }
          this.$confirm('确定审核通过吗?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              return edit(adonData)
            })
            .then(() => {
              this.onLoad()
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            })
        }

        if (command === '2') {
          this.nVisible = true
          this.nInfo.id = row.id
        }
        if (command === '3') {
          this.editVisible = true
          this.$nextTick(() => {
            this.$refs.activitiesEdit.init(row)
          })
        }

        if (command === '4') {
          this.viewVisible = true
          this.$nextTick(() => {
            this.$refs.dataView.init(row)
          })
        }

        if (command === '6') {
          const adonData = {
            id: row.id,
            isDisabled: 1
          }
          this.$confirm('下架后不支持上架，确认下架吗?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              return edit(adonData)
            })
            .then(() => {
              this.onLoad()
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            })
        }
      },
      handleSubmit() {
        this.$refs.nInfo.validate((valid) => {
          if (valid) {
            const adonData = {
              id: this.nInfo.id,
              remark: this.nInfo.remark,
              state: 3
            }
            edit(adonData).then((resp) => {
              if (resp.code === 0) {
                this.nVisible = false
                this.nInfo.remark = ''
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
                this.onLoad()
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
